// extracted by mini-css-extract-plugin
module.exports =  {"container":"wage_advisor-module_container_b1dae","note":"wage_advisor-module_note_e723b","reportLink":"wage_advisor-module_reportLink_d950c"};